<template>
  <span class="all-category">分类：</span>
  <div v-if="$route.query.maID">
    <ul class="app-header-nav" v-for="fitems in menulist" :key="fitems.chID">
      <li>
        <RouterLink
          :class="{ active: parseInt($route.query.firstCate) == fitems.chID }"
          :to="`?maID=${$route.query.maID}&firstCate=${fitems.chID}`"
          >{{ fitems.chName }}
        </RouterLink>
      </li>
    </ul>
    <hr />
    <div style="margin-left: 55px" v-if="subList">
      <ul class="app-header-nav" v-for="sitems in subList" :key="sitems.coID">
        <li v-show="$route.query.firstCate">
          <RouterLink
            :class="{
              active: parseInt($route.query.secondCate) == sitems.coID,
            }"
            :to="`?maID=${$route.query.maID}&firstCate=${$route.query.firstCate}&secondCate=${sitems.coID}`"
            >{{ sitems.coName }}
          </RouterLink>
        </li>
      </ul>
    </div>

    <div style="margin-left: 50px">
      <hr />
      <ul class="titems" v-for="items in thrList" :key="items.clID">
        <li>
          <RouterLink
            :class="{ active: parseInt($route.query.thirdCate) == items.clID }"
            :to="`?maID=${$route.query.maID}&firstCate=${$route.query.firstCate}&secondCate=${$route.query.secondCate}&thirdCate=${items.clID}`"
            >{{ items.clName }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
  <div v-else>
    <ul class="app-header-nav" v-for="fitems in menulist" :key="fitems.chID">
      <li>
        <RouterLink
          :class="{ active: parseInt($route.query.firstCate) == fitems.chID }"
          :to="`?firstCate=${fitems.chID}`"
          >{{ fitems.chName }}
        </RouterLink>
      </li>
    </ul>
    <hr />
    <div style="margin-left: 80px" v-if="subList">
      <ul class="app-header-nav" v-for="sitems in subList" :key="sitems.coID">
        <li v-show="$route.query.firstCate">
          <RouterLink
            :class="{
              active: parseInt($route.query.secondCate) == sitems.coID,
            }"
            :to="`?firstCate=${$route.query.firstCate}&secondCate=${sitems.coID}`"
            >{{ sitems.coName }}
          </RouterLink>
        </li>
      </ul>
    </div>

    <div style="margin-left: 75px">
      <hr />
      <ul class="titems" v-for="items in thrList" :key="items.clID">
        <li>
          <RouterLink
            :class="{ active: parseInt($route.query.thirdCate) == items.clID }"
            :to="`?firstCate=${$route.query.firstCate}&secondCate=${$route.query.secondCate}&thirdCate=${items.clID}`"
            >{{ items.clName }}
          </RouterLink>
        </li>
      </ul>
    </div>
  </div>
  <div class="major">
    <hr />
    <div class="list">
      <span>网校：</span>
      <ul class="major-item" v-for="item in major" :key="item.index">
        <!-- <li>
          <RouterLink
            :class="{ active: $route.query.maID == item.maID }"
            :to="`?maID=${item.maID}`"
            >{{ item.maName }}</RouterLink
          >
        </li> -->
        <li
          @click="choseMajor(item.maID)"
          :class="{ active: $route.query.maID == item.maID }"
        >
          <img
            style="width: 30px; height: 30px; border-radius: 50%"
            :src="item.maImg"
            alt=""
          />
          {{ item.maName }}
        </li>
      </ul>
    </div>
  </div>
  <hr />
</template>

<script>
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { computed, watch, ref, reactive } from "vue";

export default {
  // eslint-disable-next-line vue/no-setup-props-destructure
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const major = computed(() => {
      const list = store.state.category.list.filter((item) => {
        return item.aid == 0;
      });
      return list.map((vtem) => {
        return {
          maID: vtem.maID,
          maName: vtem.maName,
          maImg: vtem.maImg,
        };
      });
    });

    const menulist = computed(() => {
      let list = store.state.category.list.filter((items) => items.pid === 0);
      return list;
    });

    const subList = computed(() => {
      let list = store.state.category.list.filter(
        (item) => parseInt(item.caID) === parseInt(route.query.firstCate)
      );
      return list.sort((a, b) => {
        return a.coID - b.coID;
      });
    });
    const thrList = computed(() => {
      return store.state.category.list.filter(
        (item) => item.cbID === parseInt(route.query.secondCate)
      );
    });

    const choseMajor = (maID) => {
      if (
        route.query.firstCate &&
        route.query.secondCate &&
        route.query.thirdCate
      ) {
        router.push(
          `/video?maID=${maID}&firstCate=${route.query.firstCate}&secondCate=${route.query.secondCate}&thirdCate=${route.query.thirdCate}`
        );
      } else if (route.query.firstCate && route.query.secondCate) {
        router.push(
          `/video?maID=${maID}&firstCate=${route.query.firstCate}&secondCate=${route.query.secondCate}`
        );
      } else if (route.query.firstCate) {
        router.push(`/video?maID=${maID}&firstCate=${route.query.firstCate}`);
      } else {
        router.push(`/video?maID=${maID}`);
      }
    };

    return {
      menulist,
      subList,
      thrList,
      major,
      choseMajor,
    };
  },
};
</script>

<style lang="less" scoped>
hr {
  border: 1px solid rgb(252, 255, 252);
}
.all-category {
  font-size: 16px;
  line-height: 45px;
  font-weight: bold;
  height: 45px;
}
.app-header-nav {
  display: inline-block;
  padding-left: 10px;
  li {
    margin-right: 15px;
    text-align: center;
    a {
      font-size: 16px;
      line-height: 45px;
      font-weight: bold;
      height: 45px;
      display: inline-block;
    }
    &:hover {
      a {
        cursor: pointer;
        color: @shColor;
        border-bottom: 1px solid @shColor;
      }
    }
  }
}
.titems {
  display: inline-block;
  padding-left: 15px;
  li {
    margin-right: 15px;
    text-align: center;
    a {
      font-size: 14px;
      line-height: 35px;
      font-weight: bold;
      height: 35px;
      display: inline-block;
    }
    &:hover {
      a {
        cursor: pointer;
        color: @shColor;
        border-bottom: 1px solid @shColor;
      }
    }
  }
}
.major {
  .list {
    display: flex;
    align-items: center;
    span {
      font-size: 16px;
      line-height: 45px;
      font-weight: bold;
      height: 45px;
    }
    .major-item {
      display: inline-block;
      padding-left: 15px;
      li {
        margin-right: 15px;
        text-align: center;

        font-size: 14px;
        line-height: 35px;
        font-weight: bold;
        height: 35px;
        display: inline-block;

        &:hover {
          cursor: pointer;
          color: @shColor;
          border-bottom: 1px solid @shColor;
        }
      }
    }
  }
}
.active {
  color: @shColor;
  border-bottom: 1px solid @shColor;
}
</style>
